<template>
    <div>
        <div class="Nav">
            <div class="Nav_top">
                <router-link to="/writing/titleGeneration/titleGeneration" active-class="active" :class="{ 'active': $route.meta.titleGeneration }" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img2/sv68.svg" /><img src="@a/img2/sv68on.svg" /></span>
                    </div>
                    <div class="top_list_title">文章生成</div>
                </router-link>
                <router-link to="/writing/myArticles" active-class="active" :class="{ 'active': $route.meta.myArticles }"
                    class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img2/sv69.svg" /><img src="@a/img2/sv69on.svg" /></span>
                    </div>
                    <div class="top_list_title">我的文章</div>
                </router-link>
                <router-link to="/writing/planTorelease" active-class="active"
                    :class="{ 'active': $route.meta.planTorelease }" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img2/sv70.svg" /><img src="@a/img2/sv70on.svg" /></span>
                    </div>
                    <div class="top_list_title">计划发布</div>
                </router-link>
                <router-link to="/writing/siteManagement" active-class="active"
                    :class="{ 'active': $route.meta.siteManagement }" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img2/sv71.svg" /><img src="@a/img2/sv71on.svg" /></span>
                    </div>
                    <div class="top_list_title">站点管理</div>
                </router-link>
                <router-link to="/writing/releaselog" active-class="active" :class="{ 'active': $route.meta.releaselog }"
                    class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img2/sv72.svg" /><img src="@a/img2/sv72on.svg" /></span>
                    </div>
                    <div class="top_list_title">发布日志</div>
                </router-link>
                <router-link to="/writing/pictureManagement" active-class="active"
                    :class="{ 'active': $route.meta.pictureManagement }" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img2/sv73.svg" /><img src="@a/img2/sv73on.svg" /></span>
                    </div>
                    <div class="top_list_title">图片管理</div>
                </router-link>
                <router-link to="/writing/ProhibitedWords" active-class="active"
                    :class="{ 'active': $route.meta.ProhibitedWords }" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img2/sv74.svg" /><img src="@a/img2/sv74on.svg" /></span>
                    </div>
                    <div class="top_list_title">违禁词管理</div>
                </router-link>
            </div>
            <div class="Nav_bottom">
                <router-link to="/integral/rechargeChatDetails" active-class="active"
                    :class="{ 'active': $route.meta.integral }" class="Nav_bottom_list">
                    <div class="bottom_list_icon"><i class="el-icon-coin"></i></div>
                    <div class="bottom_list_title">费用</div>
                </router-link>
                <router-link to="/memberCentre/basicInformation" active-class="active"
                    :class="{ 'active': $route.meta.memberCentre }" class="Nav_bottom_list">
                    <div class="bottom_list_icon"><i class="el-icon-user"></i></div>
                    <div class="bottom_list_title">会员</div>
                </router-link>
            </div>
        </div>
        <div class="writing_nav2">
            <div class="writing_nav_con">
                <div class="AIPackage" v-show="seo_member.remaining_days>0">
                    <div class="AIPackage_title font14">{{ seo_member.vip_name }}会员</div>
                    <div class="AIPackage_time font26">{{ seo_member.remaining_days }}天</div>
                    <div class="AIPackage_timedd font12">会员剩余天数</div>
                    <div class="AIPackage_timedt font12">{{ seo_member.end_time }}到期</div>
                    <div class="AIPackage_btn font12" @click="clickAIPackageShow">开通会员，享受更多权益</div>
                </div>
                <div class="writing_nav_list" :class="{ 'active': $route.meta.requiresA }">
                    <router-link to="/writing/titleGeneration/titleGeneration" active-class="active" class="nav_list_title"><span><img src="@a/img2/sv86.svg" /><img src="@a/img2/sv86on.svg" /></span>手动生成</router-link>
                    <router-link to="/writing/titleGeneration/BackgroundHostingCreate" :class="{ 'active': $route.meta.BackgroundHostingList }" active-class="active" class="nav_list_title"><span><img src="@a/img2/sv87.svg" /><img src="@a/img2/sv87on.svg" /></span>批量生成</router-link>
                </div>
                <div class="writing_nav_list" :class="{ 'active': $route.meta.integral }">
                    <router-link to="/integral/rechargeChatDetails" active-class="active" class="nav_list_title"><span><img src="@a/img2/sv79.svg"/><img src="@a/img2/sv79on.svg"/></span>订单明细</router-link>
                    <router-link to="/integral/pointsDetails" active-class="active" class="nav_list_title" :class="{'active': $route.meta.requiresAuth}"><span><img src="@a/img2/sv80.svg"/><img src="@a/img2/sv80on.svg"/></span>积分明细</router-link>
                    <router-link to="/integral/rechargeDetails" active-class="active" class="nav_list_title"><span><img src="@a/img2/sv81.svg"/><img src="@a/img2/sv81on.svg"/></span>发票申请</router-link>
                </div>
                <div class="writing_nav_list" :class="{ 'active': $route.meta.memberCentre }">
                    <router-link to="/memberCentre/basicInformation" active-class="active" class="nav_list_title" :class="{'active': $route.meta.requiresAuth}"><span><img src="@a/img2/sv82.svg"/><img src="@a/img2/sv82on.svg"/></span>基本信息</router-link>
                    <router-link to="/memberCentre/loginLog" active-class="active" class="nav_list_title"><span><img src="@a/img2/sv83.svg"/><img src="@a/img2/sv83on.svg"/></span>登录日志</router-link>
                </div>
                <div class="writing_nav_list help">
                    <a href="https://www.ai-dog.net/help/ruanwen/3.html" target="_blank"
                        class="nav_list_title"><span><img src="@a/img2/sv85.svg" /><img
                                src="@a/img2/sv85.svg" /></span>帮助手册</a>
                </div>
            </div>
        </div>
            
        <!-- AISEO套餐弹窗 -->
        <AIPackageWindow v-if="AIPackageShow" @close="AIPackageShow = false"></AIPackageWindow>
    </div>
</template>

<script>
import AIPackageWindow from "@c/common/AIPackageWindow/AIPackageWindow";
export default {
    name: "nav",
    data() {
        return {
            AIPackageShow: false,
            seo_member: null,  // seo会员信息
        };
    },
    components: {
        AIPackageWindow
    },
    computed: {

    },
    created() {
      this.getSeoMemberInfo();  // 组件加载时获取会员信息
    },
    methods: {
      async getSeoMemberInfo() {
        try {
          const res = await this.axios.get('api/Seo/getSeoMemberInfo');

          if (res.code === 1) {
            // 直接将接口返回的 result 赋值给 seo_member
            this.seo_member = res.result;
          } else {
            console.error('获取会员信息失败:', res.msg);
          }
        } catch (error) {
          console.error('请求会员信息时出错:', error);
        }
      },
        clickAIPackageShow(){
            let that = this;
            that.AIPackageShow = true;
        },
        childMethod() {
            let that = this;
            that.AIPackageShow = true;
            console.log('子组件的方法被调用');
            // 这里可以放置子组件的逻辑
        }
    },
}
</script>

<style scoped>
@import "nav.css";
</style>